import "./index.css";
import { Homepage } from "./pages/homepage";

export function App() {
  return <Homepage />;
}

export default App;
